import React, { useState, useEffect } from "react";

import Popup from "./Popup";
import { Search } from "react-feather";
import { CFormCheck, CAvatar } from "@coreui/react";

import axiosInstance from "../apis/gvmdesk";
import useAxiosFunction from "../hooks/useAxiosFunction";
import LoadingCenter from "./LoadingCenter";

const PopupChain = props => {
  const { admin } = props;
  const [search, setSearch] = useState("");
  const [response, setResponse, loading, error, axiosFetch] = useAxiosFunction();
  const [contacts, setContacts] = useState(null);
  const [contactsCount, setContactsCount] = useState(null);
  const [visible, setVisible] = useState(false);

  const clearVariables = () => {
    setSearch("");
    setResponse(null);
    setContacts(null);
    setContactsCount(0);
    setVisible(false);
  }

  useEffect(() => {
    clearVariables();
  }, [props.trigger]);

  useEffect(() => {
    if (admin) {
      axiosFetch({
        axiosInstance,
        method: "GET",
        url: "/users/admin/all/by/" + admin.id,
        redirect_to: ""
      });
    }
  }, [props.trigger === true]);

  useEffect(() => {
    setContacts(response?.contacts?.map(contact => {
      return {
        ...contact,
        checked: true
      };
    }));
  }, [response?.contacts]);

  useEffect(() => {
    if (contacts?.length > 0) {
      let selectedContacts = contacts?.filter(contact => contact.checked == true);

      setVisible(selectedContacts.length > 0);
      setContactsCount(selectedContacts.length);
    }
  }, [contacts]);

  const onChangeCheck = (event, contact) => {
    let { checked } = event.target;

    setContacts(contacts.map(oldContact => {
      if (contact.id === oldContact.id) {
        oldContact.checked = checked;
      }

      return oldContact;
    }));
  }

  const onChangeAll = event => {
    let { checked } = event.target;

    setContacts(contacts.map(contact => {
      contact.checked = checked;

      return contact;
    }));
  }

  const avatarStyle = avatarPicture => ({
    width: "45px",
    height: "45px",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundImage: `url(${avatarPicture})`
  });

  const onSubmit = (event) => {
    event.preventDefault();

    let selectedContacts =
      contacts.filter(contact => contact.checked == true);

    console.log("The form is submitted!", selectedContacts);
  }

  const filteredConsumers = search.length > 0
    ? contacts?.filter(contact => contact.name.includes(search))
    : contacts;

  return (
    <Popup title="" trigger={props.trigger} setTrigger={props.setTrigger} >
      <form onSubmit={onSubmit}>
        <div className="x-p-20 y-p-20">
          <div className="inner-search">
            <div className="search-icon">
              <Search size={24} />
            </div>

            <input className="search-input" type="text" placeholder="Pesquisar"
              onChange={e => setSearch(e.target.value)} value={search} />
          </div>
        </div>

        {!loading && contactsCount > 0
          && <div className="x-p-20 y-p-20 pt-0 text-color">{contactsCount} {contactsCount > 1 ? "contatos selecionados" : "contato selecionado"}</div>}

        <div>
          <ul className="contact__list">
            {loading && <LoadingCenter />}

            {!loading && contacts?.length <= 0 && <div className="x-p-20 y-p-10 text-color">O(a) vendedor(a) {admin.name} não possui clientes.</div>}

            {!loading && visible && <li className="contact__item x-p-20 y-p-10 d-flex flex-row align-center">
              <div className="mr-20">
                <CFormCheck onChange={onChangeAll} />
              </div>

              <span className="text-color">Selecionar tudo</span>
            </li>}

            {!loading && filteredConsumers?.map((contact, index) => {
              return (
                <li key={contact.id} className="contact__item x-p-20 y-p-10 d-flex flex-row align-center">
                  <div className="mr-20">
                    <CFormCheck name="contacts" value={contact.id} checked={contact.checked} onChange={event => onChangeCheck(event, contact)} />
                  </div>

                  <div className="mr-10">
                    <CAvatar color="light" textColor="dark" style={avatarStyle(contact.profile_pic)} />
                  </div>

                  <span className="text-color">{contact.name}</span>
                </li>
              );
            })}
          </ul>
        </div>

        {contactsCount > 0 && <div className="popup-footer x-p-20 y-p-20">
          <button className="btn btn-primary" type="submit">Concluir</button>
          <button className="btn btn-light mr-20" type="button" onClick={() => props.setTrigger(false)}>Cancelar</button>
        </div>}
      </form>
    </Popup >
  );
}

export default PopupChain;